import { Stock } from "@/models/stock";
import { FC, useState } from "react";

import { Box } from "@mui/material";
import Tabs from "../tabs/Tabs";
import StockOptionsOverview from "./stock-options-overview/StockOptionsOverview";
import OptionMatrix from "./stock-options-matrix/StockOptionsMatrix";

const tabs = [
    { value: "options-overview", title: "Option Overview" },
    { value: "options-matrix", title: "Option Matrix" },
];

const StockOptions: FC<{ stock: Stock }> = ({ stock }) => {
    const [activeTab, setActiveTab] = useState<string>("options-overview");

    return (
        <Box sx={{ height: "100%" }}>
            <Box sx={{ height: "40px", marginLeft: "auto" }}>
                <Tabs tabs={tabs} activeTab={activeTab} setState={setActiveTab} module={"StockOptions"} route={"s/ticker/exchange/options"} handleChange={(e, newValue) => newValue && setActiveTab(newValue)} setDefault alignment="center" />
            </Box>
            <Box sx={{ height: "calc(100% - 40px)" }}>{activeTab === "options-overview" ? <StockOptionsOverview stock={stock} /> : <OptionMatrix stock={stock} />}</Box>
        </Box>
    );
};

export default StockOptions;
